import { createEntityAdapter, EntityState } from "@reduxjs/toolkit";
import { api } from "./index.api";
import { CourseFile } from "../../types/files";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import toastError from "../../components/notif";

function filesApiErrorHandler(error: FetchBaseQueryError) {
  switch (error.status) {
    default:
      toastError("unkown error please try again later");
  }
}

const filesEntity = createEntityAdapter<CourseFile, string>({
  selectId: (file: CourseFile) => file._id,
});

const fileApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCourseFiles: builder.query<
      EntityState<CourseFile, string>,
      {
        courseId: string;
      }
    >({
      query: (input) => `/courses/${input.courseId}/files`,
      transformResponse(baseQueryReturnValue, meta, arg) {
        return filesEntity.addMany(
          filesEntity.getInitialState(),
          baseQueryReturnValue as any
        );
      },
      async onQueryStarted(arg, api) {
        try {
          await api.queryFulfilled;
        } catch (error: any) {
          filesApiErrorHandler(error.error as FetchBaseQueryError);
        }
      },
      providesTags: (res, err, api) => {
        if (err) return [];
        return [
          {
            type: "files",
            id: api.courseId,
          },
        ];
      },
    }),
    addCourseFile: builder.mutation<void, { courseId: string; data: FormData }>(
      {
        query: (input) => ({
          url: `/admin/courses/${input.courseId}/files`,
          method: "POST",
          body: input.data,
        }),
        async onQueryStarted(arg, api) {
          try {
            await api.queryFulfilled;
          } catch (error: any) {
            filesApiErrorHandler(error.error as FetchBaseQueryError);
          }
        },
        invalidatesTags: (res, err, api) => {
          if (err) return [];
          return [
            {
              type: "files",
              id: api.courseId,
            },
          ];
        },
      }
    ),

    updateCourseFile: builder.mutation<
      void,
      { fileId: string; courseId: string; data: FormData }
    >({
      query: (input) => ({
        url: `/admin/courses/files/${input.fileId}`,
        method: "PUT",
        body: input.data,
      }),
      async onQueryStarted(arg, api) {
        try {
          await api.queryFulfilled;
        } catch (error: any) {
          filesApiErrorHandler(error.error as FetchBaseQueryError);
        }
      },
      invalidatesTags: (res, err, api) => {
        if (err) return [];
        return [
          {
            type: "files",
            id: api.courseId,
          },
        ];
      },
    }),

    deleteCourseFile: builder.mutation<
      void,
      { fileId: string; courseId: string }
    >({
      query: (input) => ({
        url: `/admin/courses/files/${input.fileId}`,
        method: "DELETE",
      }),
      async onQueryStarted(arg, api) {
        try {
          await api.queryFulfilled;
        } catch (error: any) {
          filesApiErrorHandler(error.error as FetchBaseQueryError);
        }
      },
      invalidatesTags: (res, err, api) => {
        if (err) return [];
        return [
          {
            type: "files",
            id: api.courseId,
          },
        ];
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetCourseFilesQuery,
  useAddCourseFileMutation,
  useUpdateCourseFileMutation,
  useDeleteCourseFileMutation,
} = fileApi;
